import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

const IconCircleClose = ({ fill, className, width, height }) => (
    <svg
        className={`apc-svg-icon ${styles.iconClose} ${className}`}
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
    >
        <path
            d="M12.80629 2.19371c2.92495 2.9264 2.92495 7.68617 0 10.61258-2.9264 2.92495-7.68617 2.92495-10.61258 0-2.92495-2.9264-2.92495-7.68617 0-10.61258 2.9264-2.92495 7.68762-2.92495 10.61258 0zm-2.6431 7.87865c.19908-.19905.19908-.52266 0-.7217L8.26742 7.45392l1.80586-1.80426c.19908-.20033.19908-.52266 0-.7217-.20036-.20034-.52403-.20034-.72311 0L7.5443 6.73221 5.64855 4.8368c-.19908-.19905-.52147-.19905-.72183 0-.19908.19904-.19908.52265 0 .7217l1.89576 1.89544-1.98567 1.98662c-.19908.19904-.19908.52265 0 .7217.19908.20033.52275.20033.72183 0l1.98567-1.98533 1.89705 1.89544c.19908.19905.52275.19905.72183 0z"
            fillRule="evenodd"
        />
    </svg>
);

IconCircleClose.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconCircleClose.defaultProps = {
    fill: '#FFF',
    className: '',
    width: 20,
    height: 20,
};

export default IconCircleClose;
